import MembershipProgramEdit from "@/MembershipPrograms/MembershipProgramEdit.vue";
import MembershipProgramNew from "@/MembershipPrograms/MembershipProgramNew.vue";
import ProgressBillingScheduleForm from "@/ProgressBilling/ProgressBillingScheduleForm.vue";
import WarrantyProgramEdit from "@/WarrantyPrograms/WarrantyProgramEdit.vue";
import WarrantyProgramNew from "@/WarrantyPrograms/WarrantyProgramNew.vue";

export default [
  {
    path: "/membership_programs/new",
    name: "MembershipProgramNew",
    component: MembershipProgramNew,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/membership_programs/:id",
    name: "MembershipProgramEdit",
    component: MembershipProgramEdit,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/warranty_programs/new",
    name: "WarrantyProgramNew",
    component: WarrantyProgramNew,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/warranty_programs/:id",
    name: "WarrantyProgramEdit",
    component: WarrantyProgramEdit,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/payment_schedules/new",
    name: "PaymentScheduleNew",
    component: ProgressBillingScheduleForm,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/payment_schedules/:id",
    name: "PaymentScheduleEdit",
    component: ProgressBillingScheduleForm,
    meta: {
      permissionRoles: ["account_settings"]
    }
  }
];
